import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    menu: false,
    content: {},
    soundStatus: false,
    currentZoom: 5,
    selectedEntity: null,
    // selectedEntity: 0,
    isEntityGood: false,
    selectedService:{entity: null, service: null}
  },
  mutations: {
    mutateMenu(state, menu) {
      state.menu = menu;
    },
    setContent(state, data) {
      state.content = data;
    },
    setSound(state, status) {
      state.soundStatus = status;
    },
    setSelectedEntity(state, entity) {
      state.selectedEntity = entity;
    },
    setZoom(state, value) {
      /**
       * value must be :
       * 	5 => entity
       * 	10 => services
       * 	100 => collaborators
       */
      state.currentZoom = value;
    },
    setIsEntityGood(state, value){
      state.isEntityGood = value
    },
    setSelectedService(state, {entity, service}){
        state.selectedService = {entity, service}
    }
  },
  actions: {
    toggleMenu(context) {
      this.commit("mutateMenu", !context.state.menu);
    },
    async fetchContent() {
      try {
        let data = await fetch("./assets/content/content.json")
          .then((res) => res.json())
          const links = data.entities
          data.entities = []
          for(const link of links){
            const entity = await fetch(`./assets/content/${link}`).then((res) => res.json())
            data.entities.push(entity)
          }



            this.commit("setContent", data);
        console.log(data)
      } catch (error) {
        console.log(error);
      }
    },
    toggleSound(context, { status = null }) {
      if (status === null) {
        this.commit("setSound", !context.state.soundStatus);
      } else {
        this.commit("setSound", status);
      }
    },
    // microscope zoom
    zoomIn(context) {
      switch (context.state.currentZoom) {
        case 5:
          this.commit("setZoom", 10);
          return;
        case 10:
          this.commit("setZoom", 100);
          return;
      }
    },
    zoomOut(context) {
      switch (context.state.currentZoom) {
        case 10:
          this.commit("setZoom", 5);
          return;
        case 100:
          this.commit("setZoom", 10);
          return;
      }
    },
  },
});
